import { firestore, firestoreStatic } from '@/plugins/firebase'
import MessageModel from "@/models/message";
import ChatRoomModel from "@/models/chatroom";
import isEmpty from "is-empty";
// Services
import UsersDataService from "@/services/UsersDataService"

// const USERS = '/users'
const USERS_ITEM = '/users/:userId'
// const USERS_MEDIA = '/users_media'
const USERS_MEDIA_LIST = '/users_media/:userId/list'
// const USERS_MEDIA_ITEM = '/users_media/:userId/list/:mediaId'
// const USERS_PRIVATE = '/users_private'
const USERS_PRIVATE_ITEM = '/users_private/:userId'
const USERS_SUBSCRIPTIONS_ITEM = '/users_subscriptions/:subscriptionId'
const USERS_PACKS_ITEM = '/users_packs/:packId'
// const BLOCK_PHONE = '/blocked_phone'
const BLOCK_PHONE_ITEM = '/blocked_phone/:phone'
// const CHATROOMS = '/chat_rooms'
const CHATROOMS_ITEM = '/chat_rooms/:chatRoomId'
const LIKES_ITEM = '/likes/:likeId'

export default {

    async setMainMedia (userId, media) {
        const pathUser = USERS_ITEM.replace(':userId', userId);
        const pathMediaList = USERS_MEDIA_LIST.replace(':userId', userId);
        const pathMedia = pathMediaList + '/'+media.mediaId;
        const mediaListRef = firestore.collection(pathMediaList);
        const mediaType = media.typeMedia;
        const snap = await mediaListRef
            .where('rank', '==', 1)
            .where('type', '==', media.typeMedia)
            .get();

        const batch = firestore.batch();
        if (snap.size > 0) {
            const oldDoc = snap.docs[0];
            batch.update(firestore.doc(pathMediaList+'/'+oldDoc.id), 'rank', media.rankMedia);
        }

        if (mediaType === 0) {
            batch.update(firestore.doc(pathUser), {
                photo: media.thumbFileName
            });
        }
        else {
            batch.update(firestore.doc(pathUser), {
                video: media.thumbFileName
            });
        }

        batch.update(firestore.doc(pathMedia), {
            rank: 1
        });
        return batch.commit();
    },

    async deleteUserMedia (userId, media) {
        const pathUser = USERS_ITEM.replace(':userId', userId);
        const pathMediaList = USERS_MEDIA_LIST.replace(':userId', userId);
        const pathMedia = pathMediaList + '/'+media.mediaId;
        const mediaListRef = firestore.collection(pathMediaList);
        const snap = await mediaListRef
            .where('rank', '>', media.rankMedia)
            .where('type', '==', media.typeMedia)
            .get();

        const changeMain = media.rankMedia === 1;

        let updateUserObj = {
            countMedia: firestoreStatic.FieldValue.increment(-1)
        };
        if (changeMain) {
            if (media.typeMedia === 0)
                updateUserObj.photo = '';
            else if (media.typeMedia === 1)
                updateUserObj.video = '';
        }

        const batch = firestore.batch();
        batch.delete(firestore.doc(pathMedia));
        if (snap.size > 0) {
            let foundNewMain = false;
            snap.forEach(doc => {
                let data = doc.data();
                window.console.log("deleteUserMedia snap data", doc.id, data);
                if (changeMain && !foundNewMain && data.isValid === true) {
                    if (media.typeMedia === 0 && data.type === media.typeMedia) {
                        foundNewMain = true;
                        updateUserObj.photo = data.thumbFileName;
                    }
                    else if (media.typeMedia === 1 && data.type === media.typeMedia) {
                        foundNewMain = true;
                        updateUserObj.video = data.thumbFileName;
                    }
                }
                batch.update(firestore.doc(pathMediaList+'/'+doc.id), 'rank', data.rank-1);
            });
        }

        if (media.typeMedia === 0 && updateUserObj.photo === '') {
            UsersDataService.sendNotification(userId, {
                typeNotification: 'photoDeleted',
            })
        }

        batch.update(firestore.doc(pathUser), updateUserObj);
        return batch.commit();
    },

    async validUserMedia (userId, media) {
        const pathMediaList = USERS_MEDIA_LIST.replace(':userId', userId);
        const pathMedia = pathMediaList + '/'+media.mediaId;
        return firestore.doc(pathMedia).update({isValid: true, analyzed: true, status: "S"});
    },

    updateUserPublic (userId, data) {
        const pathUser = USERS_ITEM.replace(':userId', userId);
        return firestore.doc(pathUser).update(data);
    },

    updateUserPrivate (userId, data) {
        const pathUser = USERS_PRIVATE_ITEM.replace(':userId', userId);
        return firestore.doc(pathUser).update(data);
    },

    removePremium (userId) {
        const pathUser = USERS_PRIVATE_ITEM.replace(':userId', userId);
        return firestore.doc(pathUser)
            .update({
                isSubscribed: 0,
                hasLifeTimeEnabled: 0,
                hasLifeTimeStartedAt: null,
                locationAuto: true,
            });
    },

    deleteSubscription (userId, subscription) {
        const batch = firestore.batch();

        const pathUser = USERS_PRIVATE_ITEM.replace(':userId', userId);
        const userRef = firestore.doc(pathUser);

        const pathSubscription = USERS_SUBSCRIPTIONS_ITEM.replace(":subscriptionId", subscription.documentId);
        const subRef = firestore.doc(pathSubscription);

        batch.update(userRef, {
            isSubscribed: 0,
            locationAuto: true,
            subscriptionId: null
        });

        batch.update(subRef, {
            status: "C",
            canceledAt: firestoreStatic.FieldValue.serverTimestamp(),
            periodEndAt: firestoreStatic.FieldValue.serverTimestamp(),
            origin: "admin"
        })

        return batch.commit();
    },

    cancelSubscription (subscription) {
        const pathSubscription = USERS_SUBSCRIPTIONS_ITEM.replace(":subscriptionId", subscription.documentId);
        return firestore.doc(pathSubscription)
            .update({
                status: "C",
                canceledAt: firestoreStatic.FieldValue.serverTimestamp(),
                origin: "admin"
            });
    },

    cancelUserPack (userId, pack) {
        const batch = firestore.batch();

        const pathUser = USERS_PRIVATE_ITEM.replace(':userId', userId);
        const userRef = firestore.doc(pathUser);

        const pathPack = USERS_PACKS_ITEM.replace(":packId", pack.packId);
        const packRef = firestore.doc(pathPack);

        const packData = {
          status: "C",
          canceledAt: firestoreStatic.FieldValue.serverTimestamp(),
        };

        const userData = {};
        if (pack.packType === "IB") {
            userData.iceBreakersReloadId = null;
        }
        else if (pack.packType === "B") {
            userData.boostsReloadId = null;
        }
        batch.update(userRef, userData);
        batch.update(packRef, packData);

        return batch.commit();
    },

    deleteToken (userId, token) {
        const obj = {
            tokens: firestoreStatic.FieldValue.arrayRemove(token)
        };
        return this.updateUserPrivate(userId, obj);
    },

    updateAlerts (userId, alerts) {
        const obj = {
            notifications: alerts
        };
        return this.updateUserPrivate(userId, obj);
    },

    blockPhone (phone, adminId) {
        const path = BLOCK_PHONE_ITEM.replace(':phone', phone);
        const obj = {
            blockedAt: firestoreStatic.Timestamp.fromDate(new Date()),
            blockedBy: adminId
        };
        return firestore.doc(path + '/'+phone).set(obj);
    },

    async sendMessage(userId, message) {
        if (isEmpty(userId)) {
            return {
                status: false,
                error: "user not exists !"
            };
        }

        const messageModel = new MessageModel();
        messageModel.setUserId("0");
        messageModel.setCreatedAt(new Date());
        messageModel.setUserIds(["0", userId]);
        messageModel.setText(message);
        messageModel.setType(0);
        messageModel.setRead(false);

        // process chatRoom
        const chatRoomId = '0-' + userId;
        const chatRoomItemPath = CHATROOMS_ITEM.replace(':chatRoomId', chatRoomId);
        const chatRoomRef = firestore.doc(chatRoomItemPath);
        const chatRoomDoc = await chatRoomRef.get();
        if (!chatRoomDoc.exists) {
            // create chatRoom
            try {
                const chatRoomModel = new ChatRoomModel();
                chatRoomModel.setDocumentId(chatRoomId);
                chatRoomModel.setCreatedAt(new Date());
                chatRoomModel.setLastMessageAt(new Date());
                chatRoomModel.setUserIds(["0", userId]);
                chatRoomModel.setLastMessageUserId("0");
                chatRoomModel.setLastMessage(message);
                chatRoomModel.setLastMessageType(0);
                chatRoomModel.setLastMessageIsRead(false);
                chatRoomModel.setDisabled(false);
                window.console.log("chatRoomModel.toObject");
                window.console.log(chatRoomModel.toObject());
                await chatRoomRef.set(chatRoomModel.toObject());
            }
            catch(error) {
                window.console.error(error);
                return {
                    status: false,
                    error: "unable to create chatroom: " + error.toString()
                };
            }
        }
        else {
            // update chatRoom
            try {
                const chatRoomUpdate = {
                  lastMessage: message,
                  lastMessageIsRead: false,
                  lastMessageUserId: "0",
                  lastMessageAt: new Date()
                };
                await chatRoomRef.update(chatRoomUpdate);
            }
            catch(error) {
                window.console.error(error);
                return {
                    status: false,
                    error: "unable to update chatroom: " + error.toString()
                };
            }
        }

        // add message
        const messageRef = firestore.doc(chatRoomItemPath).collection("list").doc();
        messageModel.setDocumentId(messageRef.id);
        try {
            window.console.log("messageModel.toObject");
            window.console.log(messageModel.toObject());
            await messageRef.set(messageModel.toObject());
            return {
                status: true,
                messageId: messageRef.id
            };
        }
        catch (error) {
            window.console.error(error);
            return {
                status: false,
                error: "unable to add message: " + error.toString()
            };
        }
    },

    /**
     * Settings
     */

    loadStartChatInstructions() {
        return firestore.doc("/settings/chatroom_start_instructions")
            .get()
            .then((snap) => {
                if (snap.exists) {
                    return Promise.resolve(snap.data());
                }
                else {
                    return Promise.reject("no instructions");
                }
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    saveStartChatInstructions(instructions) {
        return firestore.doc("/settings/chatroom_start_instructions").update({
            instructions: instructions,
            updatedAt: firestoreStatic.FieldValue.serverTimestamp()
        });
    },

    loadCloseChatInstructions() {
        return firestore.doc("/settings/chatroom_close_instructions")
            .get()
            .then((snap) => {
                if (snap.exists) {
                    return Promise.resolve(snap.data());
                }
                else {
                    return Promise.reject("no instructions");
                }
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    saveCloseChatInstructions(instructions) {
        return firestore.doc("/settings/chatroom_close_instructions").update({
            instructions: instructions,
            updatedAt: firestoreStatic.FieldValue.serverTimestamp()
        });
    },

    async loadReviewsInstructions() {
        const snap = await firestore.doc("/settings/reply_instructions").get();
        if (snap.exists) {
            return snap.data().instructions;
        }

        return "";
    },

    saveReviewsInstructions(instructions) {
        return firestore.doc("/settings/reply_instructions").update({
            instructions: instructions,
            updatedAt: firestoreStatic.FieldValue.serverTimestamp()
        });
    },

    /**
     * VideoLikes
     */

    async deleteVideoLike(videoLike, adminId) {
        const pathVideoLike = LIKES_ITEM.replace(':likeId', videoLike.documentId);
        return firestore.doc(pathVideoLike).update({
            videoValid: false,
            disabled: true,
            checkedAt: new Date(),
            checkedBy: adminId
        });
    },

    async validVideoLike(videoLike, adminId) {
        const pathVideoLike = LIKES_ITEM.replace(':likeId', videoLike.documentId);
        return firestore.doc(pathVideoLike).update({
            videoValid: true,
            disabled: false,
            checkedAt: new Date(),
            checkedBy: adminId
        });
    }
}
